























import Vue, { PropOptions } from 'vue'
import MessageTab from '@/components/MessageTab.vue'
import IconTrash from '@/components/icons/IconTrash.vue'
import Button from '@/components/Button.vue'

export default Vue.extend({
  name: 'MessagesTabs',
  components: { MessageTab, IconTrash, Button },
  props: {
    messages: {
      type: Array,
      default: () => [],
    } as PropOptions,
    activeTab: {
      type: Number,
      default: () => 0,
    },
  },
})
